import axios from 'axios';

//로그인 관련 store
const loginStore = {
    state: {
        isLogin: false,
        loginID: '',
        userName: '',
        userType: '',
        accountInfo: [],
        accountInfoOrigin: [],
    },
    mutations: {
        setLogin(state, data) {
          if (data.result == 'success') {
              state.isLogin = true;
              state.loginID = data.user_id;
              state.userName = data.user_name;
              state.userType = data.user_type;
          } else if (data.result == 'fail') {
              state.isLogin = false;
              state.loginID = '';
              state.userName = '';
              state.userType = '';
          }
  
          window.location.replace('/');
        },
  
        logout(state) {
          state.isLogin = false;
          state.loginID = '';
          state.userName = '';
          state.userType = '';
  
          window.location.replace('/');
        },
  
        setAccountInfo(state, data) {
          state.accountInfo = data;
          state.accountInfoOrigin = data;
        },
  
    },
    actions: {
        //로그인
        async login(context, data) {
        axios.post(`/login`, { 'user_id': data.id, 'user_pw': data.pw })
            .then((res) => {
            //console.log(res.data);
              if(res.data.result == 'fail'){
                context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '로그인'
                                            ,'alertContent': `로그인 실패..!|${res.data.message}`});
              }else{
                context.commit('setLogin', res.data);
              }
            })
            .catch((error) => {
              context.commit('setAlert', {  'alertStatus': 'error'
                                            ,'alertTitle': '로그인'
                                            ,'alertContent': `오류 발생|${error}`});
            })
        },
  
        //계정 정보 조회
        async getAccountInfo(context) {
        axios.get(`/account/list`, {
          headers: {
                      'Authorization': context.rootGetters.getCryptNum
          }
        })
            .then((res) => {
              context.commit('setAccountInfo', res.data);
            })
            .catch((error) => {
              context.commit('setAlert', {  'alertStatus': 'error'
                                            ,'alertTitle': '사이트 계정 정보 조회'
                                            ,'alertContent': `오류 발생|${error}`});
            })
        },
  
        //계정 정보 입력
        async insertAccountInfo(context, data) {
        axios.post(`/account/insert`, { 'user_id': data.user_id
                                        ,'user_pw': data.user_pw
                                        ,'user_name': data.user_name
                                        ,'user_type': data.user_type
                                        ,'insert_date': data.insert_date
                                        }, {
                                          headers: {
                                                      'Authorization': context.rootGetters.getCryptNum
                                          }
                                        })
            .then((res) => {
            if(res.data.result == 'success'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '사이트 계정 정보 입력'
                                            ,'alertContent': res.data.message});
                context.dispatch('getAccountInfo');
            }else if(res.data.result == 'fail'){
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '사이트 계정 정보 입력'
                                            ,'alertContent': res.data.message});
            }else{
              context.commit('setAlert', {  'alertStatus': 'notice'
                                            ,'alertTitle': '사이트 계정 정보 입력'
                                            ,'alertContent': '입력 시 오류 발생|관리자 문의 필요'});
            }
            })
            .catch((error) => {
              context.commit('setAlert', {  'alertStatus': 'error'
                                            ,'alertTitle': '사이트 계정 정보 입력'
                                            ,'alertContent': `오류 발생|${error}`});
            })
        },
  
        //계정 정보 삭제
        async deleteAccountInfo(context, data){
          axios.post(`/account/delete`, {
              '_id': data.id
          }, {
            headers: {
                        'Authorization': context.rootGetters.getCryptNum
            }
          })
          .then((res) => {
              if(res.data.result == 'success'){
                context.commit('setAlert', {  'alertStatus': 'notice'
                                              ,'alertTitle': '사이트 계정 정보 삭제'
                                              ,'alertContent': res.data.message});
                context.dispatch('getAccountInfo');
              }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '사이트 계정 정보 삭제'
                                          ,'alertContent': `오류 발생|${error}`});
          })
        },
  
        //계정 비밀번호 변경
        async changePassword(context, data){
          axios.post(`/account/change/password`, {
            'login_id': this.state.login.loginID,
            'current_password': data.curPW,
            'new_password': data.newPW01,
            'update_date': data.updateDT
          }, {
            headers: {
                        'Authorization': context.rootGetters.getCryptNum
            }
          })
          .then((res) => {
            context.commit('setAlert', {  'alertStatus': 'notice'
                                          ,'alertTitle': '비밀번호 변경'
                                          ,'alertContent': res.data.message});
            if(res.data.result == 'success'){
              context.commit('logout');
            }
          })
          .catch((error) => {
            context.commit('setAlert', {  'alertStatus': 'error'
                                          ,'alertTitle': '비밀번호 변경'
                                          ,'alertContent': `오류 발생|${error}`});
          })
        }
    },
    getters: {
      getUserType(state){
        return state.userType;
      },

      getUserName(state){
        return state.userName;
      },

      getCryptNum(state) {
        if(state.isLogin) {
          const num = Math.floor(Math.random()*1000);
          //const val = Math.floor(new Date().getTime() / 10000.0).toString().slice(-4);
          const val = 'tmpCryptNum';

          return val + ':' + num;
        } else {
          return ':';
        }
      },
    }
  
  }

  export default loginStore;